export enum CHECKLIST_STATUS {
  DONE = 'done',
  IN_PROGRESS = 'in_progress',
  SKIPPED = 'skipped',
}

export enum CHECKLIST_TEMPLATE {
  NEW_MWM_APP = 'create_new_application',
  NEW_PUBLISHING_APP = 'new_publishing_app',
  VERSION_RELEASE = 'version_release',
}

export type ChecklistTeam =
  | 'admin'
  | 'backend'
  | 'business_development'
  | 'cesar'
  | 'cloud'
  | 'damien'
  | 'data_team'
  | 'developers_team'
  | 'developers_team_and_backend'
  | 'ludo'
  | 'marketing_team'
  | 'monet'
  | 'monetization_team'
  | 'pm_and_mobile'
  | 'pm_and_publishing'
  | 'product_managers_team'
  | 'product_managers_team_and_business_development'
  | 'product_managers_team_and_cesar'
  | 'product_managers_team_and_rania'
  | 'product_monetization_squad_team'
  | 'product_owners'
  | 'publishing'
  | 'rania'
  | 'ua'
  | 'ua_and_mobile'
  | 'ua_and_product_managers_team'
  | 'ua_and_rania'

export interface ICreateOrUpdateReleaseChecklist {
  changelog: string
  developersTeamToAPI: string[]
  productManagerTeamToAPI: string[]
  productMonetizationSquadTeamToAPI: string[]
  relatedVersionToAPI: string
  releaseDate: string
}

export interface ICreateOrUpdatePublishingAppChecklist {
  backendTeamToAPI: string[]
  businessDevelopmentTeamToAPI: string[]
  developersTeamToAPI: string[]
  productManagerTeamToAPI: string[]
  uaTeamToAPI: string[]
}

export interface ICreateOrUpdateMwmAppChecklist {
  adminTeamToAPI: string[]
  backendTeamToAPI: string[]
  dataTeamToAPI: string[]
  developersTeamToAPI: string[]
  marketingTeamToAPI: string[]
  monetizationTeamToAPI: string[]
  productOwnerTeamToAPI: string[]
  uaTeamToAPI: string[]
}

export interface IChecklistTask {
  assignation_key: ChecklistTeam
  checklist_id: string
  created_at: string
  created_at_ts: number
  created_by: string
  description: string
  executed_by: string
  id: string
  mattermost_posts: string[] | null
  previous_tasks: string[] | null
  status: CHECKLIST_STATUS
  title: string
  ui_config: {
    pipeline_index: number
    step_index: number
    task_index: number
  }
  updated_at: string
  updated_at_ts: number
  updated_by: string
}

export interface IChecklistPipeline {
  tasks: IChecklistTask[]
}

export interface IChecklistStep {
  pipelines: IChecklistPipeline[]
}

export interface IChecklist extends IDBContextExtended {
  application_id: string
  application_semantic_version?: string
  application_version_id?: string
  assignation_mapping: Record<ChecklistTeam, string[]>
  description: string
  due_date?: string
  id: string
  notification_icon_url: string
  status: CHECKLIST_STATUS
  steps: IChecklistStep[]
  tasks: unknown[]
  template: CHECKLIST_TEMPLATE
  title: string
}
